import React, { useContext, useEffect, useRef } from 'react';
import SideMenu from '../../Splitter/SideMenu/SideMenu';
import { devis } from '../../../utils/images';
import { ClientContext } from '../../Contexts/contexts';
import HeaderMinimal from '../../Shared/Headers/HeaderMinimal';
import QuoteElementUser from '../QuoteElementUser/QuoteElementUser';
import useAuth from '../../Contexts/useAuth';

function WaitingAcceptationUser() {
  const clientContext = useContext(ClientContext);
  const { checkAuth, validateRoleRoute } = useAuth();
  const ref = useRef(true);

  function GetRelations() {
    return clientContext?.clientExpertRelations?.filter(
      (relation) => relation?.status < 2 && relation?.status > -2
    );
  }

  useEffect(() => {
    const isFirstRendering = ref.current;
    if (checkAuth()) {
      if (validateRoleRoute('client')) {
        if (isFirstRendering) {
          clientContext?.refreshClientExpertRelations();
          //clientContext?.refreshAppointments();
          ref.current = false;
        }
      }
    }
  });

  return (
    <>
      <HeaderMinimal />
      <div className="ts-container">
        <SideMenu />
        <div className="ts-container-column">
          <div className="ts-details-container">
            <div className="ts-details">
              <div className="ts-title">En attente d’acceptation</div>
              <div className="ts-resume">
                Pourriez-vous s'il vous plaît confirmer si vous avez conclu un
                contrat avec l'expert ?<br />
                Merci.
              </div>
            </div>
            <div className="ts-number">
              <div className="ts-number-container">
                <div className="ts-number-title">En attente d’acceptation</div>
                <div className="ts-number-current">1</div>
              </div>
              <img className="ts-icon" src={devis} alt="devis"></img>
              <div className="yellow-rod"></div>
            </div>
          </div>

          {GetRelations()?.length > 0 && (
            <div className="waiting-container">
              <div className="waiting-nomenclature">
                <span className="waiting-nomenclature-demand">Demande</span>
                <span className="waiting-nomenclature-amount">
                  Montant estimé
                </span>
                <span className="waiting-nomenclature-note">Note</span>
              </div>
              <div className="waiting-elements-container">
                {GetRelations()?.map((relation) => (
                  <QuoteElementUser
                    id={relation.id}
                    key={relation.id}
                    clientExpertRelation={relation}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default WaitingAcceptationUser;
